export const migrations = {};
export default migrations;